export namespace IRealNameIdentification {
  export namespace Common {
    export enum IdentificationStatus {
      UNVERIFIED = 'not verified',
      VERIFIED = 'verified',
    }

    export enum ClaimStatus {
      UNCLAIMED = 'not claimed',
      CLAIMED = 'claimed',
    }
  }

  export namespace Request {
    export interface IdentificationInfoReq {
      contact_name: string;
      id_number: string;
      phone: string;
    }
  }

  export namespace Response {
    export interface IdentificationInfoRes {
      verifyStatus: IRealNameIdentification.Common.IdentificationStatus;
      contactName: string;
      idNumber: string;
      phone: string;
    }
  }
}
